import { SelectChangeEvent } from '@mui/material';

import { ISearchRender, IViewRender } from '/shared/SelectSearchList';

import { CustomTagWithCounter, CustomValueWithCounter } from '../types';

export interface ITagsSelectProps<
  V extends { value: string; count: number } = CustomValueWithCounter,
  T extends { key: string; count: number; values: V[] } = CustomTagWithCounter<V>,
> {
  onSelect: (key: string, value?: string) => void;
  mainColor: { color?: string; colorDark?: string; backgroundColor: string; backgroundColorDark?: string };
  tag: T;
  selected?: boolean;
  isSelectable?: boolean;
  className?: string;
  addCustomValue?: boolean;
}

export enum IKeyToSort {
  COUNT = 'count',
  NUMBER = 'number',
  ABC = 'ABC',
  DATE = 'date',
}
export enum IDirectionToSort {
  ASC = 'asc',
  DESC = 'desc',
}

export type ISearchCustomInputProps = Omit<Parameters<ISearchRender>[0], 'closeAnchorEl'> & {
  submitValue: (val: string) => void;
};

export interface ITypeSort {
  keyToSort: IKeyToSort;
  direction: IDirectionToSort;
}
export type ISortFunction = <V extends { value: string; count: number }>(a: V, b: V) => number;
export type ISortOptionsProps = {
  handleChange: (event: SelectChangeEvent) => void;
  changeDirectionSort: () => void;
  typeSort: ITypeSort;
};

export type IViewSelectProps = Parameters<IViewRender>[0] & {
  showDropdownWithSelect: boolean;
  hasOnlyDropdown: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  tagKey: string;
} & Pick<ITagsSelectProps, 'mainColor' | 'selected'>;
